export const FORGOT_LOGIN = 'events/FORGOT_LOGIN';

/**
 * @param email
 * @param extension
 * @return {{type: string, payload: {email:*, extension:*}}}
 */
export const forgotLogin = (email, extension) => ({
  type: FORGOT_LOGIN,
  payload: { email, extension },
});
